// A kiosk printer's rear tray holds one kind of paper at a time. The admin sets which
// and how many sheets; the kiosk offers only what the tray holds and counts the sheets
// down. Photos are also switched on for each kiosk by an admin, apart from what its
// tray holds. The same values as the cloud's utils/rearTray.js.

export const REAR_TRAY_MEDIA = [
  { value: "none", label: "Empty" },
  { value: "matte-a4-200", label: "A4 white matte inkjet · 200 g/m²", short: "A4 matte 200 g/m²" },
  { value: "photo-10x15", label: "10×15 photo paper", short: "10×15 photo" },
];
// More than the tray takes, so a bigger count is a typing mistake
export const REAR_TRAY_MAX = 100;

// The paper in the tray, or undefined when it is empty
const paperIn = (printer) =>
  REAR_TRAY_MEDIA.find(
    (item) => item.value !== "none" && item.value === (printer.rearTray && printer.rearTray.media)
  );

const sheetsOf = (printer) =>
  typeof printer.rearTray.paper === "number" ? printer.rearTray.paper : 0;

// "10×15 photo paper · 14 sheets", or "Empty"
export const rearTrayText = (printer) => {
  const paper = paperIn(printer);
  return paper ? paper.label + " · " + sheetsOf(printer) + " sheets" : "Empty";
};

// Whether photos are switched off for the kiosk, as they are until an admin switches
// them on. The cloud then tells the kiosk its tray is empty, whatever it holds, and
// gives it no photo file.
export const photosOff = (printer) => printer.photoEnabled !== true;

// The tray for the printer list, as { label: "10×15 photo", sheets: 14 }, with "off" for
// the sheets while photos are switched off, or null when the tray is empty
export const rearTrayStat = (printer) => {
  const paper = paperIn(printer);
  if (!paper) return null;
  return {
    label: paper.short,
    sheets: paper.value === "photo-10x15" && photosOff(printer) ? "off" : sheetsOf(printer),
  };
};

// Whether a kiosk that sells from its tray has lowAt sheets or fewer left in it
export const rearTrayLow = (printer, lowAt) =>
  Boolean(paperIn(printer)) && (paperIn(printer).value !== "photo-10x15" || !photosOff(printer)) && sheetsOf(printer) <= lowAt;
